<template>
    <div>
        <v-data-table
            class="astra-table"
            dense
            height="76vh"
            fixed-header
            :headers="controller.getColumnsAccess()"
            :options.sync="controller.options"
            :server-items-length="controller.vehicleMaintenancePagination.total"
            :items="controller.vehicleMaintenancePagination.items"
            :loading="controller.loading"
            :footer-props="{
                'items-per-page-options': [40, 80],
            }"
        >
            <template v-slot:[`item.description`]="{ item }">
                <div class="description-cell" @click="item.expanded = !item.expanded">
                    <div :class="{'description-content': true, 'expanded': item.expanded}">
                        {{ item.description }}
                    </div>
                </div>
            </template>

            <template v-slot:[`item.isolated`]="{ item }">
                <v-checkbox
                    color="primary"
                    class="mt-0 pt-0"
                    v-model="item.isolated"
                    hide-details
                    readonly
                    dense
                ></v-checkbox>
            </template>

            <template v-slot:[`item.hadCost`]="{ item }">
                <div>
                    <v-checkbox v-if="!item.hadCost"
                        color="primary"
                        class="mt-0 pt-0"
                        v-model="item.hadCost"
                        hide-details
                        readonly
                        dense
                    ></v-checkbox>
                    <div v-else class="d-flex align-center">
                        <v-checkbox
                            color="primary"
                            class="mt-0 pt-0"
                            v-model="item.hadCost"
                            hide-details
                            readonly
                            dense
                        ></v-checkbox>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-2"
                                >   
                                    Ver detalhes
                                    <v-icon small right class="ml-1">mdi-chevron-down</v-icon>
                                </v-chip>
                            </template>
                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Valor: {{ item.cost ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.cost / 100) : '' }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Responsável: {{ item.costResponsibility }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
            </template>
 
            <template v-slot:[`item.actions`]="{ item }">
                <div>
                    <v-btn 
                        v-if="hadPermission(0,0)"
                        icon 
                        @click="controller.delete(item)" 
                        class="px-2">
                        <v-icon color="deleteBtn" small>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>

            <template v-slot:top>
                <v-row class="pa-3" no-gutters>
                    <v-col
                        :class="
                            $vuetify.breakpoint.smAndDown
                            ? 'py-3 d-flex align-center justify-center'
                            : 'd-flex align-center'
                        "
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                        >
                        <span class="table-title">Registro de atendimentos</span>
                        </v-col>

                        <v-col
                        :class="
                        $vuetify.breakpoint.smAndDown
                            ? 'd-flex flex-column align-center justify-center'
                            : 'd-flex align-center justify-end'
                        "
                        cols="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                        >
                            <v-text-field
                                v-if="!hadPermission(0, 0)"
                                class="pa-2 search-tf"
                                style="max-width: 330px"
                                outlined
                                color="primary"
                                hide-details
                                dense
                                placeholder="Pesquisar veículo/cliente..."
                                v-model="controller.search"
                            ></v-text-field>
                            <v-text-field
                                v-else
                                class="pa-2 search-tf"
                                style="max-width: 330px"
                                outlined
                                color="primary"
                                hide-details
                                dense
                                placeholder="Pesquisar veículo/cliente/alter. por..."
                                v-model="controller.search">
                            </v-text-field>
                            <v-btn
                            v-if="!hadPermission(0,0)"
                            class="action-btn d-flex justify-center white--text"
                            height="40"
                            width="120"
                            color="green"
                            tile
                            @click.stop="controller.exportExcelClientAdmin()"
                            :loading="controller.loadingBtnExcel"
                        >
                            <v-icon left>mdi-file-excel-outline</v-icon>
                            Excel   
                        </v-btn>

                        <v-btn
                            v-else
                            class="action-btn d-flex justify-center white--text"
                            height="40"
                            width="120"
                            color="green"
                            tile
                            @click.stop="controller.exportExcel()"
                            :loading="controller.loadingBtnExcel"
                        >
                            <v-icon left>mdi-file-excel-outline</v-icon>
                            Excel 
                        </v-btn>
                    </v-col> 
                </v-row>
            </template>
            <template v-slot:[`item.createdDate`] = "{ item }">
                {{ dayjs(item.createdDate).format("DD/MM/YYYY HH:mm") }}
            </template>
            <template v-slot:[`item.equipments`]="{ item }">
                <div v-if="item.equipments && item.equipments.length">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                small
                                v-bind="attrs"
                                v-on="on"
                                class="ma-2"
                            >
                                {{ item.equipments.length }} Equipamento(s)
                                <v-icon small right>mdi-chevron-down</v-icon>
                            </v-chip>
                        </template>
                        <v-list dense>
                            <v-list-item
                                v-for="(equipment, index) in item.equipments"
                                :key="index"
                            >
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ equipment.model }}
                                        <v-chip
                                            x-small
                                            :color="equipment.type === 'Jammer Principal' ? 'primary' : 'primary'"
                                            :outlined="equipment.type !== 'Jammer Principal'"
                                            :class="equipment.type !== 'Jammer Principal' ? 'primary--text' : ''"
                                            text-color="white"
                                        >
                                            {{ equipment.type }}
                                        </v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <span v-else></span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import { hadPermission } from '@/core/domain/model/permission';
    import { vehicleMaintenanceController } from '@/di/di';
    export default {
        name: 'vehicleMaintenance-page',
        data: (context) => ({
            controller: vehicleMaintenanceController(context),
        }),
        watch: {
            "controller.options"() {
                this.controller.watchOptions();
            },
            "controller.search"() {
                this.controller.watchSearch();
            },
            "controller.clientOptions"() {
                this.controller.watchClientOptions();
            },
            "controller.searchClient": _.debounce(function () {
                this.controller.watchClientSearch();
            }, 500),
            "controller.vehicleOptions"() {
                this.controller.watchVehicleOptions();
            },
            "controller.searchVehicle": _.debounce(function () {
                this.controller.watchVehicleSearch();
            }, 500),
        }
    }
</script>

<style scoped lang="scss">
    .astra-table {
        border-radius: 20px;
        background-color: var(--v-secondary-base) !important;
    }

    .toolbar-table {
        border-top-left-radius: 20px !important;
        border-top-right-radius: 20px !important;
    }

    ::v-deep .v-data-table.v-data-table--fixed-header thead th {
        background-color: var(--v-secondary-base) !important;
    }

    .action-btn {
        text-transform: none;
        border-radius: 10px !important;
    }

    .search-tf {
        border-radius: 10px !important;
    }

    .table-title {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
    }

    .crud-card {
        border-radius: 20px;
        background-color: var(--v-secondary-base) !important;
    }

    .v-chip {
        height: 24px !important;
    }

    .v-list-item {
        min-height: 32px !important;
    }

    .description-cell {
        cursor: pointer;
    }

    .description-content {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-clamp: 3;
    }

    .description-content.expanded {
        max-width: none;
        white-space: normal;
        -webkit-line-clamp: unset;
        line-clamp: 3;
    }

    ::v-deep tbody {
        tr:hover {
            background-color: var(--v-tertiary-base) !important;
        }
    }
</style>